import routes from './routes';

export * from './api/index';
export * from './Pages/index';
export * from './Components/index';

export default routes;
